import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) =>
  createStyles({
    popper: {
      zIndex: 1000,
      marginBottom: '-40px',
      marginRight: '-10px',
    },
    layersViewBox: {
      maxWidth: '380px',
      minWidth: '320px',
      backgroundColor: '#FFFFFF',
      borderRadius: '8px',
      padding: '16px',
    },
    header: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: '8px',
    },
    title: {
      fontSize: '16px',
      color: '#001D29',
      fontWeight: 600,
    },
    closeButton: {
      padding: '4px',
      '&:hover': {
        backgroundColor: theme.palette.grey[100],
      },
    },
    content: {
      display: 'flex',
      flexDirection: 'column',
      gap: '4px',
      '& .MuiCheckbox-root': {
        color: '#646464',
        '&.Mui-checked': {
          color: '#001D29',
        },
      },
    },
    checkboxLabel: {
      margin: 0,
      '& .MuiFormControlLabel-label': {
        fontSize: '12px',
        color: '#001D29',
        fontWeight: 600,
      },
      '& .MuiCheckbox-root': {
        padding: '2px 8px 2px 0px',
      },
      '& .Mui-disabled': {
        opacity: 0.5,
      },
    },
  }),
)
